<template>
  <div>
  <el-table v-if="!isMobileViewport" :data="list" border stripe v-loading="loading">
    <el-table-column v-if="showUserColumn" label="用户信息" min-width="180">
      <template slot-scope="{ row }">
        <div class="user-main">
          <div class="user-main__title">
            {{ row.user && row.user.nickname ? row.user.nickname : "--" }}
          </div>
          <div class="user-main__sub">
            ID {{ row.user && row.user.id ? row.user.id : "--" }} /
            {{ row.user && row.user.username ? row.user.username : "--" }}
          </div>
        </div>
      </template>
    </el-table-column>

    <el-table-column v-if="showUserColumn" label="归属信息" min-width="150">
      <template slot-scope="{ row }">
        <div class="info-lines">
          <div>
            APP ID：{{ row.user && row.user.app_id ? row.user.app_id : "--" }}
          </div>
          <div>
            渠道ID：{{
              row.user && row.user.channel_id ? row.user.channel_id : "--"
            }}
          </div>
        </div>
      </template>
    </el-table-column>

    <el-table-column prop="order_id" label="账单单号" min-width="160" />
    <!-- <el-table-column label="业务类型" min-width="140" align="center">
      <template slot-scope="{ row }">
        {{ row.biz_type || "--" }}
      </template>
    </el-table-column> -->
    <el-table-column label="来源类型" min-width="120" align="center">
      <template slot-scope="{ row }">
        {{ row.source_type || "--" }}
      </template>
    </el-table-column>
    <!-- <el-table-column label="业务状态" min-width="120" align="center">
      <template slot-scope="{ row }">
        {{ row.biz_status || "--" }}
      </template>
    </el-table-column> -->
    <el-table-column label="收益归属" width="110" align="center">
      <template slot-scope="{ row }">
        <el-tag :type="String(row.is_app) === '1' ? 'warning' : 'success'">
          {{ String(row.is_app) === "1" ? "平台收益" : "用户收益" }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="增减方向" width="100" align="center">
      <template slot-scope="{ row }">
        <el-tag :type="row.type === 'increase' ? 'success' : 'danger'">
          {{ row.type || "--" }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="remark" label="备注" min-width="140" />
    <el-table-column label="金额" min-width="140" align="center">
      <template slot-scope="{ row }">
        <div>
          {{ formatMoneyRaw(row.money_num) }} ≈
          <span class="money-value">{{
            formatMoneyDisplay(row.money_num)
          }}</span>
        </div>
      </template>
    </el-table-column>
    <!-- <el-table-column prop="percentage" label="比例" width="90" align="center" /> -->
    <el-table-column
      prop="advertisers_id"
      label="广告主ID"
      min-width="120"
      align="center"
    />
    <!-- <el-table-column label="广告事件" min-width="180">
      <template slot-scope="{ row }">
        <div class="info-lines">
          <div>名称：{{ row.accessad && row.accessad.name ? row.accessad.name : "--" }}</div>
          <div>Trans ID：{{ row.accessad && row.accessad.trans_id ? row.accessad.trans_id : "--" }}</div>
          <div>Prime RIT：{{ row.accessad && row.accessad.prime_rit ? row.accessad.prime_rit : "--" }}</div>
          <div>Mediation RIT：{{ row.accessad && row.accessad.mediation_rit ? row.accessad.mediation_rit : "--" }}</div>
          <div>ECPM：{{ row.accessad && row.accessad.ecpm ? row.accessad.ecpm : "--" }}</div>
        </div>
      </template>
    </el-table-column> -->
    <el-table-column label="创建时间" min-width="160" align="center">
      <template slot-scope="{ row }">
        {{ formatTime(row.created_time) }}
      </template>
    </el-table-column>
  </el-table>
  <mobile-record-list
    v-else
    :rows="list"
    :loading="loading"
    :title="getMobileBillTitle"
    :subtitle="getMobileBillSubtitle"
    :fields="mobileBillFields"
  />
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showUserColumn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mobileBillFields() {
      return [
        {
          label: "用户",
          value: (row) => (row.user && (row.user.nickname || row.user.username)) || "--",
        },
        { label: "来源类型", key: "source_type" },
        {
          label: "金额",
          value: (row) => `${this.formatMoneyRaw(row.money_num)} ≈ ${this.formatMoneyDisplay(row.money_num)}`,
        },
        {
          label: "收益归属",
          value: (row) => (String(row.is_app) === "1" ? "平台收益" : "用户收益"),
          tag: true,
          tagType: (row) => (String(row.is_app) === "1" ? "warning" : "success"),
        },
        { label: "账单单号", key: "order_id", summary: false },
        {
          label: "用户ID",
          value: (row) => row.user && row.user.id,
          summary: false,
        },
        {
          label: "APP ID",
          value: (row) => row.user && row.user.app_id,
          summary: false,
        },
        {
          label: "渠道ID",
          value: (row) => row.user && row.user.channel_id,
          summary: false,
        },
        { label: "增减方向", key: "type", summary: false },
        { label: "备注", key: "remark", summary: false },
        { label: "广告主ID", key: "advertisers_id", summary: false },
        { label: "创建时间", value: (row) => this.formatTime(row.created_time), summary: false },
      ];
    },
  },
  methods: {
    getMobileBillTitle(row) {
      return row.order_id || `流水 #${row.id}`;
    },
    getMobileBillSubtitle(row) {
      return `流水ID ${row.id || "--"}`;
    },
    formatMoneyRaw(value) {
      const num = Number(value || 0);
      return num.toFixed(2);
    },
    formatMoneyDisplay(value) {
      const num = Number(value || 0) / 100000;
      return num.toFixed(2);
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
  },
};
</script>

<style lang="less" scoped>
.user-main__title {
  font-weight: 600;
  color: #203864;
}

.user-main__sub {
  margin-top: 4px;
  color: #8090ac;
  font-size: 12px;
}

.info-lines {
  line-height: 1.7;
  color: #516b96;
}

.money-value {
  color: #e67e22;
}
</style>
